import { BaseService } from "./BaseService";

export class PalmaresService extends BaseService {
  getPalmaresReport(model) {
    return this.request("api/Palmares/GetPalmaresReport", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(model),
    });
  }

  getPalmaresPdf(filter) {
    return this.request("api/Palmares/GetPalmaresPdf", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getPalmaresIA(UUID) {
    return this.request(`api/Palmares/GetPalmaresIA/${UUID}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
    });
  }

  getPalmaresIAPdf(filter) {
    return this.request("api/Palmares/GetPalmaresIAPdf", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }

  getPalmaresIAExcel(filter) {
    return this.request("api/Palmares/GetPalmaresIAExcel", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(filter),
    });
  }
}

const palmaresService = new PalmaresService();

export default palmaresService;
